<template>
  <div id="banner2">
    <div class="w" style="font-size: 16px;">
      <div class="hs1">
        天相财富防非宣传月｜网络直播平台“非法荐股”活动风险警
      </div>
      <div class="hs2">
        <div class="anniu">导读</div>
        <div class="wenzi">
          某些不法分子以销售“荐股软件”为名从事非法证券投资咨询活动，虚假宣传、夸大收益，谋取巨额利润，严重扰乱市场秩序。
        </div>
      </div>
      <div class="hs3">
        <img style="width: 1200px;height: 675px;" src="../assets/img/banner2/蒙版分组.png" alt="" />
        <div class="text1">
          直播平台上的播主有偿提供荐股服务，未取得证券投资咨询从业资格的，或者取得证券投资咨询从业资格但未在证券投资咨询机构或证券公司执业的，涉嫌非法从事证券投资咨询业务。
        </div>
        <div class="text2">来源|证监会网站</div>
        <div class="text3">
          北京银保监局指出，一些非法组织或个人打着为消费者维权的旗号，推出“代理投诉”“代理退保”“代理处置信用卡债务”等所谓“代理维权”服务诱骗消费者，名为代理维权，实则牟取非法利益，严重损害消费者合法权益，扰乱金融市场正常秩序。
        </div>
        <div class="text4">来源|和讯网</div>
      </div>
      <div class="wenzis" style="margin-bottom: 50px;">
        近年来，通过电视、广播、报刊等传统媒体“非法荐股”已大幅减少，但利用网络直播平台“非法荐股”的增多。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        主要表现为：个人或机构在网络直播平台开通直播房间，成为“主播”“播主”“圈主”，以“股神”“大V”“老师”自居，号称拥有资深投资背景、神奇实战业绩，以“分享炒股技巧”“锁定牛股”“推荐黑马股”等吸引眼球，利用“高手指导”“大佬看盘”“名家谈股”等名目宣传诱导投资者充值购买“金币”“鲜花”等平台虚拟币或礼品，通过“直播订阅”“收费文章”“付费问答”等各种项目让投资者持续缴费。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        此类直播荐股是一种新的招术，诱惑力强，播主头衔多变、身份隐秘，投资者往往难以识破。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        上述机构和个人经常在门户网站、财经网站、微博、股吧、抖音等打广告、聚人气，预留直播地址，向直播平台引流；投资者被诱导后，通常演变为签订指导炒股协议、投资咨询合同，并收取高额咨询费或指导费，甚至约定高比例收益分成。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        <span style="font-weight: 600;color: rgba(255, 0, 0, 1);margin-bottom: 30px;">
          根据国家有关规定，网络直播荐股收费属于证券投资咨询活动，未经许可，任何机构和个人不得从事此类活动。
        </span>
        直播平台上的播主有偿提供荐股服务，未取得证券投资咨询从业资格的，或者取得证券投资咨询从业资格但未在证券投资咨询机构或证券公司执业的，涉嫌非法从事证券投资咨询业务；上述直播平台运营机构未取得证券投资咨询业务资格的，涉嫌非法经营证券业务或者为非法活动提供便利。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        在此提醒广大投资者，<span style="font-weight: 600;">获取证券投资建议请通过证券公司或合法证券投资咨询机构进行，上述合法证券机构名单可在证监会、证券业协会网站查询；
        </span>请不要与无资格机构和个人合作，远离“非法荐股”，避免利益损失。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        从事证券相关业务的机构，须经中国证监会批准获得相关业务资格，证券从业人员须通过所在机构向中国证券业协会申请执业资格方可上岗。合法的证券经营机构在开展业务活动中一般使用对公账户，请投资者切勿向个人账户汇款，并自觉远离提供所谓“内幕股”的非法机构，摒弃“一夜暴富”观念，保持理性投资心态，切记“天上不会掉馅饼”。
      </div>
      <div class="wenzis" style="margin-bottom: 50px;">
        同时提醒各网络直播平台，未取得证券投资咨询业务资格的，不得从事任何直播荐股活动；取得证券投资咨询业务资格的，不得为无资格机构和个人从事直播荐股提供便利。
      </div>
      <div class="hs4" style="margin-bottom: 50px;">
        <img src="../assets/img/banner2/中间.png" alt="" />
      </div>
      <div class="hs5">
        <img src="../assets/img/banner2/四大途径.png" alt="" />
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        3月15日，北京银保监局发布消费者风险提示称，警惕非法"代理维权"侵害，依法理性维护自身权益。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        <span
          style="color: rgba(255, 0, 0, 1);font-weight: 600;">一是选择适当的金融产品或服务。</span>广大消费者应根据实际需求，结合自身经济情况和风险承受能力，选择适当的金融产品或服务。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        <span
          style="color: rgba(255, 0, 0, 1);font-weight: 600;">二是拒绝非法代理维权行为。</span>非法代理维权组织或个人以"代理维权"之名，捏造事实、违背合同约定，不仅扰乱正常金融秩序，甚至涉嫌寻衅滋事和敲诈勒索，突破法律底线。消费者应珍惜个人信用，警惕参与非法“代理维权"可能面临的法律风险，不轻信虚假承诺，拒绝参与违背合同约定、提供虚假信息、编造事实的恶意投诉。
      </div>
      <div class="wenzis" style="margin-bottom: 30px;">
        <span
          style="color: rgba(255, 0, 0, 1);font-weight: 600;">三是依法理性维护自身权益。</span>消费者在购买金融机构产品或享受服务过程中发生纠纷的，可以直接向金融机构投诉，主张民事权益。若消费者未能与金融机构通过协商解决纠纷，可以向行业调解组织申请调解。通过投诉、调解仍不能解决民事纠纷的，消费者可以根据合同约定，提请仲裁机构仲裁或向人民法院提起诉讼。
      </div>
      <div class="wenzis" style="margin-bottom: 50px;">
        <span
          style="color: rgba(255, 0, 0, 1);font-weight: 600;">四是防止个人信息外泄。</span>增强个人信息安全意识，保护好个人金融信息和家庭信息，避免出现信息外泄、信息盗用等风险，给自身信息安全埋下隐患。如发现合法权益受到不法行为侵害，应及时向公安机关报案。
      </div>
      <div class="hs6">附：《防范和处置非法集资条例》干货</div>
      <div class="hs7" style="margin-bottom: 10px;">
        <img src="../assets/img/banner2/防非.png" alt="" />
      </div>
      <div class="hs9">
        来源|中国银保监会
      </div>
      <div class="hs8">
        郑重声明：本公众号图文及音像内容版权归北京天相财富管理顾问有限公司所有，未经允许不得转载或用于任何商业用途，否则将视为侵权，本公司拥有追究权利；已授权的转载或者引用内容时请注明来源。股市有风险，投资需谨慎。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner2",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.w {
  width: 1200px;
  margin: 0 auto;

  .hs1 {
    width: 100%;
    text-align: center;
    font-size: 38px;
    font-weight: 700;
    padding-top: 53px;
    margin-bottom: 53px;
  }

  .hs2 {
    width: 1200px;
    height: 70px;
    opacity: 1;
    border-radius: 10px;
    background: rgba(247, 247, 247, 1);
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 50px;

    .anniu {
      width: 76px;
      height: 30px;
      line-height: 30px;
      opacity: 1;
      border-radius: 50px;
      background: rgba(163, 23, 30, 1);
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      margin-right: 20px;
    }

    .wenzi {
      font-size: 18px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      vertical-align: middle;
    }
  }

  .hs3 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);

    .text1 {
      margin-top: 9px;
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      text-indent: 2em;
    }

    .text2 {
      font-size: 14px;
      font-weight: 400;
      text-indent: 2em;
      width: 100%;
      text-align: right;
      margin-top: 10px;
      margin-bottom: 31px;
    }

    .text3 {
      font-size: 14px;
      font-weight: 400;
      text-indent: 2em;
      color: rgba(153, 153, 153, 1);
      text-align: left;
    }

    .text4 {
      font-size: 14px;
      font-weight: 400;
      text-indent: 2em;
      width: 100%;
      text-align: right;
      margin-bottom: 50px;
    }
  }

  .wenzis {
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-indent: 2em;
    line-height: 35px;
  }

  .hs5 {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .hs6 {
    width: 100%;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: left;
    margin-bottom: 30px;
  }

  .hs8 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    vertical-align: middle;
    text-indent: 2em;
    margin-bottom: 113px;
  }

  .hs9 {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    text-align: right;
    vertical-align: middle;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/banner2.vue